import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["static"],
  _excluded2 = ["unmount"],
  _excluded3 = ["as", "children", "refName"];
import "core-js/modules/es.object.from-entries.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { cloneElement as N, createElement as E, forwardRef as h, Fragment as g, isValidElement as P, useCallback as j, useRef as S } from "react";
import { classNames as b } from './class-names.js';
import { match as w } from './match.js';
var O = function (n) {
    return n[n.None = 0] = "None", n[n.RenderStrategy = 1] = "RenderStrategy", n[n.Static = 2] = "Static", n;
  }(O || {}),
  v = function (e) {
    return e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e;
  }(v || {});
function C(_ref) {
  var r = _ref.ourProps,
    t = _ref.theirProps,
    e = _ref.slot,
    n = _ref.defaultTag,
    o = _ref.features,
    _ref$visible = _ref.visible,
    a = _ref$visible === void 0 ? !0 : _ref$visible,
    f = _ref.name,
    l = _ref.mergeRefs;
  l = l != null ? l : k;
  var s = R(t, r);
  if (a) return m(s, e, n, f, l);
  var y = o != null ? o : 0;
  if (y & 2) {
    var _s$static = s.static,
      u = _s$static === void 0 ? !1 : _s$static,
      d = _objectWithoutProperties(s, _excluded);
    if (u) return m(d, e, n, f, l);
  }
  if (y & 1) {
    var _s$unmount = s.unmount,
      _u = _s$unmount === void 0 ? !0 : _s$unmount,
      _d = _objectWithoutProperties(s, _excluded2);
    return w(_u ? 0 : 1, _defineProperty(_defineProperty({}, 0, function _() {
      return null;
    }), 1, function _() {
      return m(_objectSpread(_objectSpread({}, _d), {}, {
        hidden: !0,
        style: {
          display: "none"
        }
      }), e, n, f, l);
    }));
  }
  return m(s, e, n, f, l);
}
function m(r) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var e = arguments.length > 2 ? arguments[2] : undefined;
  var n = arguments.length > 3 ? arguments[3] : undefined;
  var o = arguments.length > 4 ? arguments[4] : undefined;
  var _F = F(r, ["unmount", "static"]),
    _F$as = _F.as,
    a = _F$as === void 0 ? e : _F$as,
    f = _F.children,
    _F$refName = _F.refName,
    l = _F$refName === void 0 ? "ref" : _F$refName,
    s = _objectWithoutProperties(_F, _excluded3),
    y = r.ref !== void 0 ? _defineProperty({}, l, r.ref) : {},
    u = typeof f == "function" ? f(t) : f;
  "className" in s && s.className && typeof s.className == "function" && (s.className = s.className(t));
  var d = {};
  if (t) {
    var i = !1,
      c = [];
    for (var _i = 0, _Object$entries = Object.entries(t); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        T = _Object$entries$_i[0],
        p = _Object$entries$_i[1];
      typeof p == "boolean" && (i = !0), p === !0 && c.push(T);
    }
    i && (d["data-headlessui-state"] = c.join(" "));
  }
  if (a === g && Object.keys(x(s)).length > 0) {
    if (!P(u) || Array.isArray(u) && u.length > 1) throw new Error(['Passing props on "Fragment"!', "", "The current component <".concat(n, " /> is rendering a \"Fragment\"."), "However we need to passthrough the following props:", Object.keys(s).map(function (p) {
      return "  - ".concat(p);
    }).join("\n"), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map(function (p) {
      return "  - ".concat(p);
    }).join("\n")].join("\n"));
    var _i2 = u.props,
      _c = typeof (_i2 == null ? void 0 : _i2.className) == "function" ? function () {
        return b(_i2 == null ? void 0 : _i2.className.apply(_i2, arguments), s.className);
      } : b(_i2 == null ? void 0 : _i2.className, s.className),
      _T = _c ? {
        className: _c
      } : {};
    return N(u, Object.assign({}, R(u.props, x(F(s, ["ref"]))), d, y, {
      ref: o(u.ref, y.ref)
    }, _T));
  }
  return E(a, Object.assign({}, F(s, ["ref"]), a !== g && y, a !== g && d), u);
}
function I() {
  var r = S([]),
    t = j(function (e) {
      var _iterator = _createForOfIteratorHelper(r.current),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var n = _step.value;
          n != null && (typeof n == "function" ? n(e) : n.current = e);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }, []);
  return function () {
    for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
      e[_key] = arguments[_key];
    }
    if (!e.every(function (n) {
      return n == null;
    })) return r.current = e, t;
  };
}
function k() {
  for (var _len2 = arguments.length, r = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    r[_key2] = arguments[_key2];
  }
  return r.every(function (t) {
    return t == null;
  }) ? void 0 : function (t) {
    var _iterator2 = _createForOfIteratorHelper(r),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var e = _step2.value;
        e != null && (typeof e == "function" ? e(t) : e.current = t);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  };
}
function R() {
  var n;
  for (var _len3 = arguments.length, r = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    r[_key3] = arguments[_key3];
  }
  if (r.length === 0) return {};
  if (r.length === 1) return r[0];
  var t = {},
    e = {};
  for (var _i3 = 0, _r = r; _i3 < _r.length; _i3++) {
    var o = _r[_i3];
    for (var a in o) a.startsWith("on") && typeof o[a] == "function" ? ((n = e[a]) != null || (e[a] = []), e[a].push(o[a])) : t[a] = o[a];
  }
  if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(e).map(function (o) {
    return [o, void 0];
  })));
  var _loop = function _loop(_o) {
    Object.assign(t, _defineProperty({}, _o, function (a) {
      var l = e[_o];
      for (var _len4 = arguments.length, f = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        f[_key4 - 1] = arguments[_key4];
      }
      var _iterator3 = _createForOfIteratorHelper(l),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var s = _step3.value;
          if ((a instanceof Event || (a == null ? void 0 : a.nativeEvent) instanceof Event) && a.defaultPrevented) return;
          s.apply(void 0, [a].concat(f));
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }));
  };
  for (var _o in e) {
    _loop(_o);
  }
  return t;
}
function U(r) {
  var t;
  return Object.assign(h(r), {
    displayName: (t = r.displayName) != null ? t : r.name
  });
}
function x(r) {
  var t = Object.assign({}, r);
  for (var e in t) t[e] === void 0 && delete t[e];
  return t;
}
function F(r) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var e = Object.assign({}, r);
  var _iterator4 = _createForOfIteratorHelper(t),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var n = _step4.value;
      n in e && delete e[n];
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return e;
}
export { O as Features, v as RenderStrategy, x as compact, U as forwardRefWithAs, C as render, I as useMergeRefsFn };